import { commentsItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1120px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">
          观众热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          追剧小伙伴们怎么说？真实用户观影感受
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {commentsItems.map((item) => (
            <div
              key={item.id}
              className="rounded-xl bg-background-50 border border-background-200 p-5"
            >
              <div className="flex items-start gap-3 mb-3">
                <img
                  src={item.avatar}
                  alt={item.author}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0 bg-background-200"
                  loading="lazy"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.author}</span>
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-xs ${i < item.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                </div>
                <span className="flex-shrink-0 px-2.5 py-1 rounded-md bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">
                  在看《{item.show}》
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}